import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PACIFailed from "../../assets/img/PACIFailed.svg";
import StorefrontTitle from '../shared/storefront-title.component';
import Settings from '../../services/settings.service';
import Storage from '../../services/storage.service';

const subscriptions = [];
const PaciQRFailure = (props) => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})

    useEffect(() => {

        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const retryHandling = () => {
        props.retryHandling();
    }

    const skipHandling = () => {
        props.history.push("/scan/id")
    }

    const languageConvertLink = (link) => {
        if (link && link.includes("%lang%")) {
          return link.replace("%lang%", Translations.activeLang);
        } else {
          return "#";
        }
      }

    return (
        <div className="paci paci-result">
            <img src={PACIFailed} alt="" />
            {Storage.get("TryAgainEligibility", true) ? <StorefrontTitle 
                title={translationKeys["ob_id_has_not_verified"] || "Your ID has not been verified."}
                desc={translationKeys["ob_id_has_not_verified_desc"] || "Your ID has not been verified. Please try again or use a different ID."}
            /> :
            <>
                {Storage.get("PACIActvivationPending", true) ?
                    <StorefrontTitle 
                        title={translationKeys["ob_id_has_pending_actviation"] || "Activation Already Inprogress"}
                        desc={translationKeys["ob_id_has_pending_actviation_desc"] || "An activation request is already in progress for this Civil ID. Please complete the existing activation before creating a new account. If you need assistance, please contact us at 156."}
                    /> :
                    <StorefrontTitle 
                        title={translationKeys["ob_id_has_not_verified_failed"] || "Failed verification"}
                        desc={translationKeys["ob_id_has_not_verified_failed_desc"] || "You can try with a different ID type. Or visit our nearest location to update your ID, or call Member Care on 156 to request home assistance"}
                    />
                }
            </>}
            {Storage.get("TryAgainEligibility", true) ? <>
                <div className="two-common-btn-container">
                    <button
                        className="common-button" 
                        onClick={retryHandling}
                    >
                        {translationKeys["ob_try_again_paci"] || "Try again"}
                    </button>
                    <button
                        className="common-button-light" 
                        onClick={skipHandling}
                    >
                        {translationKeys["ob_try_with_another_id"] || "Try with another ID"}
                    </button>
                </div>
            </> : <>
            {Storage.get("PACIActvivationPending", true) ?
                <a
                    className="common-button-light" 
                    href={`tel:+${Settings?.call_us}`}
                >
                    {translationKeys["ob_contact_support"] || "Contact support"}
                </a>
            :
                <>
                    <div className="two-common-btn-container">
                        <button
                            className="common-button" 
                            onClick={skipHandling}
                        > 
                            {translationKeys["ob_try_with_other_id"] || "Try with other ID"}
                        </button>
                        <a
                            className="common-button-light" 
                            href={`tel:+${Settings?.call_us}`}
                        >
                            {translationKeys["ob_contact_support"] || "Contact support"}
                        </a>
                        <>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href={languageConvertLink(Settings?.footer?.get_map_stores)} className="common-a-button-transparent">{translationKeys["ob_contact_support_store"] || "Visit Store"}</a>
                        </>
                    </div>
                </>
            }
            </>}
        </div>
    )
}

export default PaciQRFailure;